if (!customElements.get("complete-your-routine")) {
  class CompleteYourRoutine extends HTMLElement {
    constructor() {
      super();
      this.drawerWrapper = null;
      this.drawer = null;
      this.backdrop = null;
      this.trigger = null;
      this.closeBtn = null;
      this.addToCartBtn = null;
      this.checkboxes = null;
      this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      this.offerMessage = null;
      this.offerText = null;
      this.copyBtn = null;
      this.offerPrice = null;
      this.currentOfferCode = "";
    }

    connectedCallback() {
      this.mode = this.dataset.mode || "popup";
      this.cacheElements();
      this.bindEvents();
      this.updateOffer();
      this.updateRoutineIcons();
      if (this.mode === "popup") {
        this.initScrollBehavior();
      } else {
        this.drawerWrapper.classList.add("active");
        this.drawer.classList.add("open");
      }
    }

    disconnectedCallback() {
      window.removeEventListener("scroll", this.handleScroll);
    }

    cacheElements() {
      const triggerSelector = this.dataset.triggerButton;
      this.trigger = document.querySelector(triggerSelector);
      this.drawerWrapper = this.querySelector(".routine-drawer-wrapper");
      this.drawer = this.querySelector(".routine-drawer");
      this.backdrop = this.querySelector(".routine-backdrop");
      this.closeBtn = this.querySelector(".routine-close");
      this.addToCartBtn = this.querySelector(".routine-add-to-cart");
      this.checkboxes = this.querySelectorAll(".routine-step input[type=checkbox]");
      this.offerMessage = this.querySelector(".routine-offer-message");
      this.offerText = this.querySelector(".routine-offer-message .offer-text");
      this.copyBtn = this.querySelector(".routine-offer-message .copy-offer");
    }

    bindEvents() {
      if (this.mode === "popup") {
      this.trigger?.addEventListener("click", () => {
        const productId = this.dataset.productId || "";
        const productName = this.dataset.productName || "";
        const productPrice = this.dataset.productPrice || "";
        const pageType = "pdp";
        const deviceType = "mweb";

        const clevertapData = {
          product_id: productId,
          product_name: productName,
          product_price: productPrice,
          page_type: pageType,
          device_type: deviceType,
        };

        dataLayer.push({
          event: "build_your_regime_clicked",
          ...clevertapData,
          clevertap: clevertapData,
        });

        this.open();
      });

      this.closeBtn?.addEventListener("click", () => this.close());
      this.backdrop?.addEventListener("click", () => this.close());
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") this.close();
      });
      }

      this.addToCartBtn?.addEventListener("click", () =>
        this.addSelectedToCart()
      );

      this.copyBtn?.addEventListener("click", () => this.copyOfferCode());

      this.checkboxes.forEach((cb, i) => {
        cb.addEventListener("change", () => {
          this.updateOffer();
          this.toggleRoutineIcon(cb);

          const anyChecked = Array.from(this.checkboxes).some(c => c.checked);
          this.addToCartBtn.disabled = !anyChecked;

          const step = cb.closest(".routine-step");
          const productName = step.querySelector(".routine-name")?.textContent?.trim();
          const productPrice = step.querySelector(".routine-price")?.textContent?.trim();
          const stepNumber = `Step ${i + 1}`;
          const selectedCount = Array.from(this.checkboxes).filter((c) => c.checked).length;
          const bundleOfferDisplayed = this.offerMessage?.textContent?.trim() || "";

          if (cb.checked) {
            const clevertapData = {
              product_name: productName,
              product_step: stepNumber,
              product_price: productPrice,
              selected_count: selectedCount,
              bundle_offer_displayed: bundleOfferDisplayed,
            };
            dataLayer.push({
              event: "complete_your_routine_product_checked",
              ...clevertapData,
              clevertap: clevertapData,
            });
          } else {
            const clevertapData = {
              product_name: productName,
              remaining_selected_count: selectedCount,
              bundle_offer_updated: bundleOfferDisplayed,
            };
            dataLayer.push({
              event: "complete_your_routine_product_unchecked",
              ...clevertapData,
              clevertap: clevertapData,
            });
          }
        });
      });
    }

    open() {
      if (this.mode !== "popup") return;
      this.drawerWrapper.classList.add("active");
      setTimeout(() => {
        this.drawer.classList.add("open");
        this.backdrop.classList.add("open");

        const routineSteps = this.querySelectorAll(".routine-step");
        const stepCount = routineSteps.length;
        const routineProducts = Array.from(routineSteps).map((step) =>
          step.querySelector(".routine-name")?.textContent?.trim()
        );
        const discountOffered = this.offerText?.textContent?.trim() || "";
        const sessionId = window.sessionStorage.getItem("session_id") || "";

        const clevertapData = {
          base_product_name: this.dataset.productName || "",
          routine_step_count: stepCount,
          routine_products: routineProducts,
          discount_offered: discountOffered,
          session_id: sessionId,
        };

        dataLayer.push({
          event: "complete_your_routine_viewed",
          ...clevertapData,
          clevertap: clevertapData,
        });
      }, 10);

      document.body.classList.add("overflow-hidden");
    }

    close() {
      if (this.mode !== "popup") return;
      this.drawer.classList.remove("open");
      this.backdrop.classList.remove("open");
      document.body.classList.remove("overflow-hidden");
      setTimeout(() => {
        this.drawerWrapper.classList.remove("active");
      }, 300);
    }

    updateOffer() {
      const selectedCount = Array.from(this.checkboxes).filter((cb) => cb.checked).length;
      let offerMsg = "";
      let offerCode = "";
      let offerPrice = "";

      if (selectedCount === 1) {
        offerMsg = this.dataset.offerMsg1;
        offerCode = this.dataset.offerCode1;
        offerPrice = this.dataset.offerPrice1;
      } else if (selectedCount === 2) {
        offerMsg = this.dataset.offerMsg2;
        offerCode = this.dataset.offerCode2;
        offerPrice = this.dataset.offerPrice2;
      } else if (selectedCount >= 3) {
        offerMsg = this.dataset.offerMsg3;
        offerCode = this.dataset.offerCode3;
        offerPrice = this.dataset.offerPrice3;
      }

      if (offerMsg && offerCode) {
        this.offerMessage.classList.remove("hidden");
        this.offerText.textContent = offerMsg;
        this.currentOfferCode = offerCode;
      } else {
        this.offerMessage.classList.add("hidden");
        this.currentOfferCode = "";
      }

      this.addToCartBtn.textContent = offerPrice ? `Add to Cart at ${offerPrice}` : "Add to Cart";

      const clevertapData = {
        offer_code: this.currentOfferCode,
        selected_product_count: selectedCount,
        total_bundle_price: offerPrice,
        discount_percent: offerMsg,
      };
      dataLayer.push({
        event: "complete_your_routine_offer_updated",
        ...clevertapData,
        clevertap: clevertapData,
      });
    }

    copyOfferCode() {
      if (!this.currentOfferCode) return;
      const copyIcon = this.copyBtn.querySelector(".icon-routine-copy");
      const copiedIcon = this.copyBtn.querySelector(".icon-routine-copied");

      navigator.clipboard
        .writeText(this.currentOfferCode)
        .then(() => {
          copyIcon?.classList.add("hidden");
          copiedIcon?.classList.remove("hidden");

          setTimeout(() => {
            copiedIcon?.classList.add("hidden");
            copyIcon?.classList.remove("hidden");
          }, 2000);
        })
        .catch(() => console.error("Failed to copy code"));
    }

    updateRoutineIcons() {
      this.checkboxes.forEach((cb) => this.toggleRoutineIcon(cb));
    }

    toggleRoutineIcon(checkbox) {
      const step = checkbox.closest(".routine-step");
      const checkedIcon = step.querySelector(".icon-routine-checked");
      const uncheckedIcon = step.querySelector(".icon-routine-unchecked");

      if (checkbox.checked) {
        checkedIcon?.classList.remove("hidden");
        uncheckedIcon?.classList.add("hidden");
      } else {
        checkedIcon?.classList.add("hidden");
        uncheckedIcon?.classList.remove("hidden");
      }
    }

    async addSelectedToCart() {
      const selectedVariants = [];
      const selectedNames = [];
      this.checkboxes.forEach((cb) => {
        if (cb.checked) {
          const step = cb.closest(".routine-step");
          const variantId = step.dataset.variantId;
          const productName = step.querySelector(".routine-name")?.textContent?.trim() || "";
          if (variantId) {
            selectedVariants.push(parseInt(variantId));
            selectedNames.push(productName);
          }
        }
      });

      if (!selectedVariants.length) {
        this.addToCartBtn.disabled = true;
        console.error("Select at least one product!");
        return;
      } else {
        this.addToCartBtn.disabled = false;
      }

      const totalPrice = this.addToCartBtn.textContent.replace("Buy Now at ", "");

      const cartRes = await fetch("/cart.js");
      const cart = await cartRes.json();
      const cartItems = cart.items || [];

      const variantsToAdd = [];
      for (const variantId of selectedVariants) {
        const existingQty = cartItems
          .filter((item) => item.variant_id === variantId)
          .reduce((sum, item) => sum + item.quantity, 0);

        if (existingQty < 4) {
          variantsToAdd.push(variantId);
        }
      }

      if (!variantsToAdd.length) {
        alert("You can only add up to 4 of each product to your cart.");
        return;
      }

      const clevertapData = {
        cta_price: totalPrice,
        selected_product_ids: variantsToAdd,
        selected_product_names: selectedNames,
        discount_code: this.currentOfferCode,
        selected_count: variantsToAdd.length,
        base_product: this.dataset.productName || "",
      };
      dataLayer.push({
        event: "complete_your_routine_cta_clicked",
        ...clevertapData,
        clevertap: clevertapData,
      });

      const formData = {
        items: variantsToAdd.map((id) => ({ id, quantity: 1 })),
      };

      if (this.cart) {
        formData.sections = this.cart.getSectionsToRender?.().map((s) => s.id);
        formData.sections_url = window.location.pathname;
        this.cart.setActiveElement?.(document.activeElement);
      }

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });

        const data = await res.json();

        const clevertapAfterData = {
          cart_value: data?.items?.reduce(
            (sum, i) => sum + i.final_line_price / 100,
            0
          ),
          added_product_names: selectedNames,
          added_product_ids: variantsToAdd,
          discount_code_applied: this.currentOfferCode,
          from_feature: "complete_your_routine_modal",
        };

        dataLayer.push({
          event: "complete_your_routine_added_to_cart",
          ...clevertapAfterData,
          clevertap: clevertapAfterData,
        });

        if (this.cart?.renderContents) this.cart.renderContents(data);
      } catch (error) {
        console.error("Error adding products:", error);
      } finally {
        if (this.cart?.classList.contains("is-empty")) {
          this.cart.classList.remove("is-empty");
        }
        this.close();
      }
    }

    initScrollBehavior() {
      this.handleScroll = () => {
        if (!this.trigger) return;

        const scrollY = window.scrollY;
        this.trigger.classList.toggle("is-collapsed", scrollY > 80);
      };

      window.addEventListener("scroll", this.handleScroll, { passive: true });
    }
  }

  customElements.define("complete-your-routine", CompleteYourRoutine);
}